import React from 'react';
import { observer, inject } from 'mobx-react'
import intl from 'react-intl-universal';
import { AllLocales } from '@/locales/index';
import Index from './pages/index';
import Preview from './pages/preview';
import { getQueryVariable,storageSetItem,storageGetItem } from "Utils/utils";
import { jaegerApi, baseUrlApis } from "Api/index";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';

function loadLocales () {
    let language = getQueryVariable('language') || 'en-US';
    switch (language.split('-')[0]) {
        case 'en':
            language = 'en-US';
            break;
        case 'zh':
            language = 'zh-CN';
            break;
        case 'ja':
            language = 'ja-JP';
            break;
        case 'ko':
            language = 'ko-KR';
            break;
        default:
            break;
    }
    intl.init({
        currentLocale: language || 'en-US', // TODO: determine locale here
        locales: AllLocales,
        fallbackLocale: 'en-US'
    })
}

function initJaeger () {
    try {
        let jaegerBaseUrl = storageGetItem(localStorage, 'jaegerBaseUrl');
        if (!jaegerBaseUrl) {
            baseUrlApis.getServerConfig().then(res => {
                if (res && res.data && res.data.jaegerBaseUrl) {
                    storageSetItem(localStorage, 'jaegerBaseUrl', res.data.jaegerBaseUrl);
                    jaegerApi.initJaeger(res.data.jaegerBaseUrl);
                }
            })
        } else {
            jaegerApi.initJaeger(jaegerBaseUrl);
        }
    } catch (err) {
        console.log(err);
        baseUrlApis.getServerConfig().then(res => {
            if (res && res.data && res.data.jaegerBaseUrl) {
                jaegerApi.initJaeger(res.data.jaegerBaseUrl);
            }
        });
    }
}

// Preview page: http://localhost:7000/preview?language=en-US&platform=IOS&isPad=1
const App = inject("appStore", "apiStore")(observer((/* props */) => {
    let model = 1;
    if (model == 1) initJaeger();
    loadLocales();
    // Dark mode: 0 for light theme, 1 for dark theme
    const isBlack = getQueryVariable('isBlack') == 1;
    let platform = getQueryVariable('platform') || 'PhantomOnline'; // Phantom FoxitReader PhantomOnline MacPhantom 
    const isPad = getQueryVariable('isPad'); // 0: not pad, 1: pad
    if (isPad == 1 && ['Android', 'IOS'].includes(platform)) platform += '-Pad';
    return (
        <Router>
            <div className={`Platform-${platform}${isBlack?' dark-mode':''}`}>
                <Switch>
                    <Route exact path="/">
                        <Index />
                    </Route>
                    <Route path="/preview">
                        <Preview />
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}));

export default App;
